import {ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit} from "@angular/core";
import {AttachmentsListComponent} from "../../../../../../../common/components/attachments";
import {AttachmentService} from "../../../../../../../../../common/services/attachment.service";
import {ModalService} from "../../../../../../../../services/modal.service";
import {ToastService} from "../../../../../../../../../common/services/toast.service";
import {SpinnerService} from "../../../../../../../../../common/services/spinner.service";
import {Table} from "../../../../../../../../../common/interfaces/table.interface";
import {PDFDocument} from "pdf-lib";

@Component({
    selector: "section-warehouse-attachments-list",
    template: `
        <common-confirm></common-confirm>
        <h1 class="container-heading">Order attachments</h1>
        <mat-card>
            <mat-card-content>
                <common-table2 *ngIf="listTable" [settings]="listTable" (onRowsSelected)="selectedRows = $event">
                    <div row1>
                        <button mat-raised-button color="primary" *ngIf="selectedRows.length" (click)="print()">
                            Print selected
                            <mat-icon>print</mat-icon>
                        </button>
                    </div>
                </common-table2>
            </mat-card-content>
        </mat-card>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class WarehouseAttachmentsListComponent extends AttachmentsListComponent implements OnInit {

    public selectedRows: any[] = [];

    public constructor(
        protected changeDetectorRef: ChangeDetectorRef,
        protected attachmentService: AttachmentService,
        protected modalService: ModalService,
        protected toastService: ToastService,
        protected spinnerService: SpinnerService
    ) {
        super(changeDetectorRef, attachmentService, modalService, toastService, spinnerService);
    }

    protected getTableId(): string {
        return "fdj87GFEDdG";
    }

    protected getActions(): Table.IAction[] {
        return [];
    }

    protected getUrl(): Table.ITableApi {
        return {
            url: ["order", this.modal.params.orderRef, "attachments"],
            query: {
                shipment_id: this.modal.params.shipment_id || null
            }
        };
    }

    protected prepareList(): void {
        this.listTable = {
            table_id: this.getTableId(),
            actions: this.getActions(),
            api: this.getUrl(),
            columns: this.getColumns(),
            multi_select: function (row: any): boolean {
                return row.extension === "pdf";
            }
        };
        this.changeDetectorRef.markForCheck();
    }

    public async print(): Promise<any> {
        try {
            this.spinnerService.show();
            // Create a fresh PDF document container
            const mergedPdf = await PDFDocument.create();

            // Fetch all PDFs as ArrayBuffers
            const fetchPromises = this.selectedRows.map((row: any) => {
                const cacheBusterUrl = `${row.path}?cb=${new Date().getTime()}`;

                return fetch(cacheBusterUrl).then(res => {
                    if (!res.ok) {
                        throw new Error(`Failed to fetch ${row.path}`);
                    }
                    return res.arrayBuffer();
                });
            });

            const pdfBuffers = await Promise.all(fetchPromises);

            // Loop through and copy pages into the merged document
            for (const buffer of pdfBuffers) {
                const pdfDoc = await PDFDocument.load(buffer);
                const copiedPages = await mergedPdf.copyPages(pdfDoc, pdfDoc.getPageIndices());
                copiedPages.forEach((page) => mergedPdf.addPage(page));
            }

            // Serialize the PDF document to bytes (a Uint8Array)
            const mergedPdfBytes = await mergedPdf.save();

            // Create a local Blob URL
            const blob = new Blob([mergedPdfBytes], {type: "application/pdf"});
            const localBlobUrl = URL.createObjectURL(blob);

            this.spinnerService.hide();

            // Open in a new tab and trigger print
            const newTab = window.open(localBlobUrl, "_blank");
            if (newTab) {
                newTab.onload = () => {
                    newTab.print();
                    // Clean up the URL object from memory after printing starts
                    URL.revokeObjectURL(localBlobUrl);
                };
            } else {
                this.toastService.show("Please allow popups to print files.", "warning");
            }

        } catch (error) {
            this.toastService.show("Error while merging PDFs: " + error.message, "error");
        }
    }

    public ngOnInit(): void {
        this.prepareList();
    }

}
